<template>
  <el-row class="warp">
     <el-col
      :span="24"
      class="warp-main"
      v-loading="loading"
      element-loading-text="拼命加载中"
    >
    		<el-alert
	    title="提示"
	    type="warning"
	    description="相同时间范围间隔缓存3分钟，只取【已完成】状态有赞订单，同步过程中请不要着急，软件运行结束会有提示！"
	    show-icon>
	  </el-alert>
           <el-form
          :model="addForm"
          label-width="80px"
          :rules="addFormRules"
          ref="addForm"
          show-overflow-tooltip
        >
          <el-form-item prop="datetimeValue" label="起始时间">
            <el-date-picker
              v-model="addForm.datetimeValue"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
              
          <el-button @click.native="addForm.datetimeValue =''">取消</el-button>
          <el-button
            type="primary"
            @click.native="addSubmit"
            :loading="addLoading"
            >有赞订单同步</el-button>     
<br/>
<!-- table -->
             <el-table
        :data="youzanorders"
        highlight-current-row
        v-loading="loading"
        style="width: 100%"
      >
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column prop="ordernumber" label="订单号"></el-table-column>
        <el-table-column prop="datetimeValue" label="创建时间"></el-table-column>
        <el-table-column prop="orderpay" label="订单金额"></el-table-column>        
        <el-table-column prop="productname" label="商品名称"></el-table-column>        
      </el-table>

     </el-col>
  </el-row>
</template>
<script>
	import API from '@/api/youzan/yzmanager'

export default {
  data() {
    return {     
      loading: false,       
      value: [],
youzanorders:[],
      //新增相关数据
    
      addLoading: false,
      addFormRules: {      
        datetimeValue: [
          { required: true, message: "请选择开始结束时间", trigger: "blur" },
        ],
      },
      addForm: {      
        datetimeValue: "",
      },
    };
  },
  methods: {
    formatBegin: function (row, column) {
      return this.dateFormatString(row.begintime);
    },
    formatEnd: function (row, column) {
      return this.dateFormatString(row.endtime);
    },   
 
    dateFormatString(data) {
      var date = new Date(data);
      var month = date.getMonth() + 1;
      const time =
        date.getFullYear() +
        "-" +
        this.dateChange(month) +
        "-" +
        this.dateChange(date.getDate()) +
        " " +
        this.dateChange(date.getHours()) +
        ":" +
        this.dateChange(date.getMinutes()) +
        ":" +
        this.dateChange(date.getSeconds());
      return time;
    },

    dateChange(m) {
      return m < 10 ? "0" + m : m;
    },

    addSubmit: function () {
      let that = this;

      var begin = "";
      var end = "";
     
      if (this.addForm.datetimeValue != "" && this.addForm.datetimeValue != null) {
         console.log(this.addForm.datetimeValue+"这是起始时间");
        begin = this.dateFormatString(
          this.addForm.datetimeValue.toString().split(",")[0]
        );
        end = this.dateFormatString(
          this.addForm.datetimeValue.toString().split(",")[1]
        );
     
      this.addForm.datetimeValue = begin + "," + end;

        this.$refs.addForm.validate((valid) => {
          if (valid) {
            that.loading = true;          
            API.add(this.addForm).then(function (result) {     
              //这是成功提示       
              if (1== result.state) {                 
                that.loading = false;
                that.$message;
                  that.youzanorders = result.data;
                that.$message.success({
                  showClose: true,
                  message: result.msg,
                  duration: 4600,
                });            
                 that.$refs["addForm"].resetFields();                
              } else {
                that.$message.error({             
                  message: result.msg || "新增失败",
                  duration: 4500,
                });
                 that.loading = false;               
              }
            });
          }
        });

       }else{
         that.$message.error({             
                message: "请选择开始和结束时间",
                duration: 2000,
              });

      }

    },
 
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$nextTick(() => {});
    },
  },

  mounted() {
   //this.handleSearch();
  },
};
</script>

<style scoped>
</style>
